import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { EventService } from "@Services/Event.Service"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { SurveyService } from "@Services/Survey.Service"
import {
    convertToDateTimeSecond,
    dbDateTimeFormat,
    generateUUID,
    localDateFormat,
    removeDateTimeZonePlus
} from "@Utils/utils"
import moment from "moment"
import { chain } from "lodash"
import Constants from "expo-constants"
const { salutance } = Constants.expoConfig.extra

export const useSurveyHandler = ({
    surveysResponses,
    user,
    setSaving,
    setProgressMessage,
    navigation,
    surveysList,
    setSurveysList,
    setLoading,
    axisId,
    allAxis,
    setCurrentQuestionIndex,
    setCurrentAxisId,
    forVideoPoint,
    currentAxisIndex,
    currentQuestionIndex,
    bgColor,
    setFetchingDiagEduc,
    setCalendarId,
    calendarId,
    axeIndex,
    axisLastItemIndex,
    educationalDEId,
    event,
    setCurrentEducationalDiagnosis,
    fromPrev,
    currentUserProgram,
    surveyParentId,
    indexToSkip,
    setIndexToSkip
}) => {
    const gotoVideoPoint = () => {
        setCurrentQuestionIndex(0)
        setCurrentAxisId(5)
        navigation.navigate("DiagnosticStack", {
            screen: "Survey",
            params: {
                axisId: allAxis[allAxis.length - 1].id,
                axisName: "Rendez-vous",
                bgColor: baseColors.black,
                allAxis: allAxis,
                forVideoPoint: true,
                axeIndex: axeIndex + 1
            }
        })
    }

    const saveResponses = () => {
        let responses = []
        if (surveysResponses && user?.id) {
            Object.keys(surveysResponses).forEach((key) => {
                responses.push(surveysResponses[key])
            })

            setSaving(true)
            setProgressMessage("Création d'un nouveau diagnostic éducatif")

            SurveyService.saveAnswers(user?.id, responses)
                .then((responses) => {
                    const newEducationalDiagnosis = responses?.data?.data
                    if (newEducationalDiagnosis) {
                        LocalStorage.saveLastAxeSurvey(0)
                        LocalStorage.saveLastAxeSurveyIndex(0)
                        setCurrentEducationalDiagnosis(newEducationalDiagnosis?.[0]?.educationalDiagnosis)
                        ShowToast({ type: "success", message: "Réponses bien enrégistrées" })
                        setSaving(false)
                        setProgressMessage("")
                        gotoVideoPoint()
                    } else {
                        ShowToast({
                            type: "error",
                            message: "Veuillez répondre correctement à tout le questionnaire"
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                    console.log(e?.response)
                    console.log(e?.response?.data)
                    setSaving(false)
                    ShowToast({ type: "error", message: "Erreur lors d'enregistrement des réponses." })
                })
        }
    }

    const OnNext = () => LocalStorage.saveSurveysResponse(surveysResponses)

    const performCreateEvent = (isSimpleRDV = false) => {
        const patientAsParticipant = {
            id: user?.id,
            type: 1
        }

        let newEvent = {
            ...event,
            calendarId: calendarId ?? 1,
            attendees: [...event.attendees, patientAsParticipant],
            isInSitu: false,
            isPublic: 0,
            locationId: 0,
            typeId: 8, //Entretien individual
            startDate: convertToDateTimeSecond(event?.startDate),
            endDate: convertToDateTimeSecond(event?.endDate),
            summary: "Entretien individuel",
            programId: currentUserProgram?.program?.id ?? 0,
            educationalDiagnosisId: educationalDEId ?? educationalDEId
        }

        delete newEvent.customLocation
        delete newEvent.specialityTypeId
        delete newEvent.consultationTypeId

        if (isSimpleRDV) {
            delete newEvent.educationalDiagnosisId
        } else {
            delete newEvent.consultationTypeId
        }

        const payload = { ...newEvent }

        setSaving(true)
        setProgressMessage("Planification d'un rendez-vous")

        EventService.create(payload)
            .then((res) => {
                ShowToast({ type: "success", message: "Évenement créer avec succès " })
                setTimeout(() => {
                    ShowToast({ type: "success", message: "Rendez-vous plannifié." })
                }, 1500)
                setSaving(false)
                isSimpleRDV ? navigation.goBack() : navigation.navigate("SurveyFinished")
            })
            .catch((err) => {
                const res = err?.response?.data
                console.log({ CreateEventError: err?.response?.data })
                if (res?.code === 400 && res?.status === "DATE_OVERLAP") {
                    ShowToast({
                        type: "error",
                        message: "Raison d'un chevauchement de date (ou d'heure)"
                    })
                } else {
                    ShowToast({ type: "error", message: "Erreur lors du création de l'évenement" })
                }
                setSaving(false)
            })
    }

    const fetchSurveys = () => {
        setLoading(true)
        SurveyService.getByAxis(axisId, surveyParentId)
            .then((response) => {
                const data = response?.data?.data
                if (data) {
                    LocalStorage.getLastAxeSurveyIndex().then((lastAxeSurveyIndex) => {
                        const removeParentItem = data?.filter((item) => item?.hasChild === 0) ?? []
                        setSurveysList(removeParentItem)
                        if (fromPrev) {
                            setCurrentQuestionIndex(removeParentItem?.length - 1)
                        } else {
                            setCurrentQuestionIndex(() => {
                                return +lastAxeSurveyIndex || 0
                            })
                        }
                        setLoading(false)
                    })
                }
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }

    const gotoNextSurvey = (axisIndex, currentAxeIndex, fromPrev = false) => {
        const axis = allAxis[axisIndex]
        setCurrentQuestionIndex(0)
        navigation.navigate("DiagnosticStack", {
            screen: "Survey",
            params: {
                axisId: axis?.id,
                axisName: axis?.name,
                bgColor: bgColor === baseColors.green.primary ? baseColors.orange.primary : baseColors.green.primary,
                allAxis: allAxis,
                axeIndex: currentAxeIndex,
                fromPrev: fromPrev
            }
        })
    }

    const handleNextBtn = () => {
        if (axeIndex === axisLastItemIndex && currentQuestionIndex == surveysList?.length - 1) {
            saveResponses()
        } else {
            if (forVideoPoint) {
            }
            if (currentAxisIndex == allAxis.length - 1 && currentQuestionIndex == surveysList.length - 1) {
            } else {
                if (currentQuestionIndex === surveysList.length - 1) {
                    gotoNextSurvey(currentAxisIndex + 1, axeIndex + 1)
                    setCurrentAxisId(currentAxisIndex + 1)
                } else {
                    setCurrentQuestionIndex(currentQuestionIndex + (indexToSkip > 0 ? indexToSkip + 1 : 1))
                    setIndexToSkip?.(0)
                }
                OnNext()
            }
        }
    }

    const handlePrevBtn = () => {
        if (+currentQuestionIndex === 0) {
            gotoNextSurvey(currentAxisIndex - 1, axeIndex - 1, true)
            setCurrentAxisId(currentAxisIndex - 1)
        } else {
            setCurrentQuestionIndex(+currentQuestionIndex - 1)
        }
    }

    const fetchEvents = () => {
        setLoading(true)
        setFetchingDiagEduc(true)
        EventService.getUsersEvents(user.id)
            .then((response) => {
                const data = response.data?.data?.items
                if (data && data instanceof Array) {
                    let events = data.filter(
                        (item) => item?.eventType?.name == EventName.DIAGNOSTIC_EDUCATIF && !item?.dayHospital?.id
                    )
                }
                setLoading(false)
                setFetchingDiagEduc(false)
            })
            .catch((e) => {
                setLoading(false)
                setFetchingDiagEduc(false)
            })
    }

    const handleFetchCalendar = () =>
        EventService.getCalendars().then((res) => {
            const data = res?.data?.data?.items?.[0]?.id ?? 1
            setCalendarId(data)
        })

    return {
        performCreateEvent,
        fetchSurveys,
        saveResponses,
        gotoNextSurvey,
        gotoVideoPoint,
        handleNextBtn,
        handlePrevBtn,
        gotoNextSurvey,
        fetchEvents,
        handleFetchCalendar
    }
}

const defaultActivity = {
    activityTypeId: null,
    sportId: null,
    duration: "",
    start: "",
    date: null,
    distance: 0,
    cardiacFrequency: 0,
    pain: 0,
    glycemy: 0
}

const defaultEvent = {
    calendarId: null,
    summary: "Entretien Individuel",
    customLocation: "",
    startDate: null,
    endDate: null,
    description: "Entretien Individuel",
    typeId: null,
    specialityTypeId: null,
    attendees: [
        {
            id: null,
            type: null
        }
    ]
}

const checkFreeslotsDateTime = (freeslots, freeslotDate) => {
    let filteredFreeslots = []
    const currentDateTime = moment(new Date()).format(localDateFormat)
    const limit = moment(new Date()).format("HH")
    if (currentDateTime === freeslotDate && freeslots?.length > 0) {
        filteredFreeslots = freeslots.filter((freeslot) => +freeslot?.startTime > +limit)
    } else {
        filteredFreeslots = freeslots
    }

    return filteredFreeslots
}

function GroupeFreeSlotsByDate({ freeslots }) {
    const freeSlotesDateOnly = freeslots?.map((freeslot) => ({
        ...freeslot,
        start_date: moment(removeDateTimeZonePlus(freeslot.start_date)).format(dbDateTimeFormat),
        end_date: moment(removeDateTimeZonePlus(freeslot.end_date)).format(dbDateTimeFormat),
        dateKey: moment(removeDateTimeZonePlus(freeslot.start_date)).format(localDateFormat),
        id: generateUUID()
    }))

    const groupedDate = chain(freeSlotesDateOnly)
        .groupBy("dateKey")
        .map((value, key) => ({ date: key, items: value }))
        .value()

    return groupedDate ?? []
}

function generateLiveKitUUID() {
    return "ivehte-" + (Math.random() + 1).toString(36).substring(4) + Date.now()
}

export { GroupeFreeSlotsByDate, defaultActivity, defaultEvent, checkFreeslotsDateTime, generateLiveKitUUID }
